import React from 'react';
import PostContent from './post/postContent';
import ArticleContent from './post/articleContent';
import VideoContent from './post/videoContent';
import PollContent from './post/pollContent';
const FeedCardContent = ({ post, isPostDetail }) => {
  const componentMap = {
    P: <PostContent isPostDetail={isPostDetail} post={post} />,
    A: <ArticleContent post={post} />,
    V: <VideoContent isPostDetail={isPostDetail} post={post} />,
    PL: <PollContent isPostDetail={isPostDetail} post={post} />,
  };
  return <React.Fragment>{componentMap[post.subType]}</React.Fragment>;
};
export default FeedCardContent;
